/**
 * @module app.bdc.list.loseOrderCtrl
 *
 */
define(['angular'], function(angular) {


    function LoseOrderCtrl($scope, $uibModalInstance) {
        var self = {};

        self.lose = function() {
            $uibModalInstance.close(true);
        };

        self.doNotLose = function() {
            $uibModalInstance.close(false);
        };

        return self;
    }

    LoseOrderCtrl.$inject = ['$scope', '$uibModalInstance', '$log'];

    angular.module('app.bdc.list.loseOrderCtrl', ['ui.bootstrap.modal']).controller('LoseOrderCtrl', LoseOrderCtrl);
});
